import './Loading.css';

export function Loading () {
    return (
        <div className='loading'>Loading...</div>
    )
}